export const AUDIO_BOUNDARY_REACHED = "AUDIO_BOUNDARY_REACHED";

export const AUDIO_CANCEL = "AUDIO_CANCEL";
export const AUDIO_CANCEL_SUCCESS = `${AUDIO_CANCEL}_SUCCESS`;

export const AUDIO_CHANGE_RATE = "AUDIO_CHANGE_RATE";
export const AUDIO_CHANGE_RATE_SUCCESS = `${AUDIO_CHANGE_RATE}_SUCCESS`;

export const AUDIO_PAUSE = "AUDIO_PAUSE";
export const AUDIO_PAUSE_SUCCESS = `${AUDIO_PAUSE}_SUCCESS`;

export const AUDIO_PLAY = "AUDIO_PLAY";

export const AUDIO_RESUME = "AUDIO_RESUME";
export const AUDIO_RESUME_SUCCESS = `${AUDIO_RESUME}_SUCCESS`;

export const AUDIO_SET_VOICE = "AUDIO_SET_VOICE";
export const AUDIO_SET_VOICE_SUCCESS = `${AUDIO_SET_VOICE}_SUCCESS`;

export const AUDIO_STOP = "AUDIO_STOP";
export const AUDIO_STOP_SUCCESS = `${AUDIO_STOP}_SUCCESS`;

export const REQUEST_OFFLINE_VOICES = "REQUEST_OFFLINE_VOICES";
export const REQUEST_OFFLINE_VOICES_SUCCESS = `${REQUEST_OFFLINE_VOICES}_SUCCESS`;

export const SKIP_TEXT_FORWARD = "SKIP_TEXT_FORWARD";
export const SKIP_TEXT_BACKWARD = "SKIP_TEXT_BACKWARD";
export const JUMP_TO_WORD = "JUMP_TO_WORD";
